import generateBasicEntityActions from './generateBasicEntityActions';

const myTaskActions = generateBasicEntityActions('tasks', 'task', 'me/tasks');

export default myTaskActions;
